import { Tea } from '@fe/game-sdk';
import { logger } from './logger';

const BE_NULL = 'be_null';

const gameTea = Tea;

interface ReportContext {
  user_unique_id?: string;
  server_id?: string | number;
  role_id?: string;
  device_id?: string;
  activity_link_id?: string;
  is_share?: string;
}

declare global {
  interface Window {
    collectEvent: (event: string, options?: Record<string, unknown>) => void;
    slardarWeb?: (method: string, params: Record<string, unknown>) => void;
  }
}

const query = Object.fromEntries(new URLSearchParams(location.search));
let context: ReportContext = {
  is_share: query.token || query.invite_code || query.is_qrcode ? location.href : BE_NULL,
};

/** 设置角色绑定信息 */
export function setReporterContext(value: ReportContext) {
  context = {
    ...context,
    ...value,
  };
}

/**
 * 兼容异步初始化的场景，先收集事件，初始化后再发送
 */
export class EventReporter {
  ready = false;
  appId?: number;
  queue: Set<{
    event: string;
    params: Record<string, string>;
  }> = new Set([]);

  /** 设置角色绑定信息 */
  setContext = setReporterContext;

  sendSlardarError(content: string) {
    window.slardarWeb?.('sendLog', {
      level: 'error',
      content: content,
    });
  }

  async init({
    appId,
    actId,
    title,
    region,
  }: {
    appId: number;
    actId: number;
    title?: string;
    region: string;
  }) {
    logger('event', 'reporter init', {
      appId,
      actId,
      region,
    });
    this.appId = appId;
    const tea = gameTea;
    tea?.initSendLogV3({
      app_id: appId,
      activity_id: actId,
      zone: region,
      // 非必传参数，这个字段可以自定义通用参数，并且会在所有埋点事件里统一传参
      default_data: {
        page_text: title,
      },
    });

    if (window.collectEvent) {
      window.collectEvent('init', {
        app_id: appId,
        channel: region,
        // 使用 localStorage
        configPersist: 2,
      });

      window.collectEvent('start');
    }
    this.ready = true;
    this.exec();
  }

  push(event: string, params: Record<string, any>) {
    this.queue.add({
      event,
      params,
    });
    this.exec();
  }

  async exec() {
    if (!this.ready) {
      return;
    }

    this.queue.forEach((task) => {
      try {
        logger('event', `${this.appId} / ${task.event}`, task.params);
        const tea = gameTea;
        tea?.sendLogV3(task.event, {
          ...context,
          ...task.params,
        });
      } catch (err) {
        console.error('event send fail', err);
      }
      this.queue.delete(task);
    });
  }
}
